import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Cattails / reeds — tall tapered blades with a brown capsule seed-head, growing
// at the shoreline (rounded art style, plan 28 stage 4 — was boxes + a cylinder).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/cattail.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, seed }) => {
    const count = 4 + Math.floor(rand(seed) * 4);
    const green = shade(0x4f7a36, (rand(seed + 1) - 0.5) * 0.2);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 5) * Math.PI * 2;
      const r = rand(seed + i * 5 + 1) * 0.3;
      const x = Math.cos(a) * r, z = Math.sin(a) * r;
      const h = 0.9 + rand(seed + i * 5 + 2) * 0.7;
      bone(x, 0, z, x, h, z, 0.045, 0.02, shade(green, (rand(seed + i) - 0.5) * 0.15)); // blade
      if (rand(seed + i * 5 + 3) > 0.4) {
        // seed head = a short vertical capsule — a cattail head literally IS one
        bone(x, h * 0.7, z, x, h * 0.7 + 0.32, z, 0.09, 0.09, 0x6b4a2b);
      }
    }
  };

export default build;
